import { render, staticRenderFns } from "./pride-2026-details.vue?vue&type=template&id=377d7734&scoped=true&lang=pug&"
import script from "./pride-2026-details.vue?vue&type=script&lang=js&"
export * from "./pride-2026-details.vue?vue&type=script&lang=js&"
import style0 from "./pride-2026-details.vue?vue&type=style&index=0&id=377d7734&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377d7734",
  null
  
)

export default component.exports